<template>
  <DefInsertTilda
    v-if="getHtmlFromTilda"
    :result="getHtmlFromTilda"
    :width="getWidth"
    :height="getHeight"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import DefInsertTilda from '@components/Def/DefInsertTilda/DefInsertTilda.vue';

export default {
  name: 'DefInsertTildaSlider',
  components: { DefInsertTilda },
  props: ['result'],
  computed: {
    ...mapGetters({
      getDeviceName: 'global/getDeviceName',
    }),
    getHtmlFromTilda() {
      return this.result?.[this.getDeviceName]?.vHtml ?? this.result.vHtml;
    },
    getWidth() {
      return this.result?.[this.getDeviceName]?.width ?? this.result.width;
    },
    getHeight() {
      return this.result?.[this.getDeviceName]?.height ?? this.result.height;
    },
  },
};
</script>

<style lang="scss" scoped>
.def-insert-tilda-slider {
}
</style>
